/** Select the CDDTI endpoint without changing pagination or other URL parameters. */
export function ofaEndpoint(url: string, isCddti: boolean = false): string {
  if (!isCddti) {
    return url;
  }

  return url.replace(/([^/?#]+)(\/?)([?#].*)?$/, (match, action, slash, parameters) =>
    `${action.endsWith('-cddti') ? action : action + '-cddti'}${slash}${parameters || ''}`
  );
}
